import Head from 'next/head';

import BookLibrary from '../../components/HomePage/BookLibrary';
import CardScrollSection from '../../components/HomePage/CardScrollSection';
import IntoSection from '../../components/HomePage/IntoSection';
import JumpStart from '../../components/HomePage/JumpStart';
import Reachout from '../../components/HomePage/Reachout';
import ReadersSection from '../../components/HomePage/ReadersSection';
import AnimatedSections from '../../components/HomePage/TextAnimation';
import { pageTitle } from '../../components/shared/basic/customHead';
import { JumpStartData } from '../../utils/data';

const AboutUs: React.FC = () => {
  return (
    <>
      <Head>
        <title>{pageTitle('About Us')}</title>
      </Head>
      <div>
        <div>
          <IntoSection />
          <div className='lg:px-20 xl:px-28 px-10 pt-10 '>
            <AnimatedSections />
          </div>

          <span className=''>
            <BookLibrary />
          </span>

          <div className='xl:pt-10 '>
            <JumpStart data={JumpStartData} />
          </div>

          <ReadersSection />

          <div className='pb-10 lg:pb-16'>
            <CardScrollSection />
          </div>
          <div className='pb-20 '>
            <Reachout />
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
